import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import toast from 'react-hot-toast';
import EnglishDatePicker from '../../components/EnglishDatePicker/EnglishDatePicker';
import Sidebar from '../../components/Sidebar';
import '../Dashboard.css';

const API_URL = process.env.REACT_APP_API_URL || 'https://metro4.dcairo.com/api';

const TodaysBreaking = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [breakingData, setBreakingData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [activeFilter, setActiveFilter] = useState('all');
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [stats, setStats] = useState({
    total: 0,
    day7: 0,
    day14: 0,
    day28: 0,
    day56: 0
  });
  
  const navigate = useNavigate();

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const fetchBreakingData = async (date = selectedDate) => {
    try {
      setLoading(true);
      const token = localStorage.getItem('token');
      
      const formattedDate = date.toISOString().split('T')[0];
      
      const response = await axios.get(`${API_URL}/pours/todays-breaking?date=${formattedDate}`, {
        headers: { Authorization: `Bearer ${token}` }
      });

      if (response.data.success) {
        const data = response.data.data;
        setBreakingData(data);
        
        const day7Count = data.filter(p => p.age === 'Day 7').length;
        const day14Count = data.filter(p => p.age === 'Day 14').length;
        const day28Count = data.filter(p => p.age === 'Day 28').length;
        const day56Count = data.filter(p => p.age === 'Day 56').length;
        
        setStats({
          total: data.length,
          day7: day7Count,
          day14: day14Count,
          day28: day28Count,
          day56: day56Count
        });
      }
    } catch (error) {
      console.error('Error fetching breaking data:', error);
      if (error.response?.status === 401) {
        toast.error('انتهت الجلسة، يرجى تسجيل الدخول مرة أخرى');
        navigate('/login');
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBreakingData();
  }, [selectedDate]);

  const handleDateChange = (date) => {
    setSelectedDate(date);
  };

  const getFilteredData = () => {
    if (activeFilter === 'all') return breakingData;
    return breakingData.filter(item => item.age === activeFilter);
  };

  const formatDate = (date) => {
    if (!date) return '-';
    const d = new Date(date);
    const day = d.getDate();
    const month = d.getMonth() + 1;
    const year = d.getFullYear();
    return (
      <div>
        <div>{`${day}/${month}`}</div>
        <div>{year}</div>
      </div>
    );
  };

  // تقسيم اسم المحطة لرقم واسم
  const formatStationName = (station) => {
    if (!station) return '-';
    const parts = station.split(' ');
    if (parts.length > 1) {
      return (
        <div>
          <div>{parts[0]}</div>
          <div>{parts.slice(1).join(' ')}</div>
        </div>
      );
    }
    return station;
  };

  const formatStation = (station) => {
    if (!station) return '-';
    // يرجع أول كلمة فقط (ST16, S15, إلخ)
    return station.split(' ')[0];
  };

  const filteredData = getFilteredData();

  return (
    <div className="dashboard-layout">
      <Sidebar isOpen={sidebarOpen} toggleSidebar={toggleSidebar} />
      
      <div className="dashboard-content">
        <div className="dashboard-header">
          <button className="menu-toggle" onClick={toggleSidebar}>
            ☰
          </button>
          <div style={{ display: 'flex', alignItems: 'center', gap: '15px', flexWrap: 'wrap' }}>
            <button 
              onClick={() => navigate('/cubes')}
              style={{
                background: 'linear-gradient(135deg, #64748b 0%, #475569 100%)',
                color: 'white',
                border: 'none',
                padding: '12px 24px',
                borderRadius: '10px',
                cursor: 'pointer',
                fontSize: '15px',
                fontWeight: '700',
                transition: 'all 0.3s',
                boxShadow: '0 4px 12px rgba(100, 116, 139, 0.3)'
              }}
              onMouseEnter={(e) => {
                e.target.style.transform = 'translateY(-2px)';
                e.target.style.boxShadow = '0 6px 20px rgba(100, 116, 139, 0.4)';
              }}
              onMouseLeave={(e) => {
                e.target.style.transform = 'translateY(0)';
                e.target.style.boxShadow = '0 4px 12px rgba(100, 116, 139, 0.3)';
              }}
            >
              ← رجوع للمكعبات
            </button>
            <h1 style={{ margin: 0 }}>🔢 تكسير اليوم</h1>
          </div>
        </div>

        <div className="dashboard-main">
          <style>{`
            .breaking-container {
              padding: 20px;
              max-width: 1600px;
              margin: 0 auto;
            }

            .date-picker-container {
              background: white;
              padding: 20px;
              border-radius: 16px;
              margin-bottom: 25px;
              box-shadow: 0 4px 20px rgba(0,0,0,0.08);
            }

            .date-picker-label {
              font-size: 16px;
              font-weight: 600;
              color: #1e293b;
              margin-bottom: 10px;
              display: block;
            }

            .alert-banner {
              background: linear-gradient(135deg, #dc2626 0%, #ef4444 100%);
              color: white;
              padding: 25px 30px;
              border-radius: 16px;
              margin-bottom: 25px;
              box-shadow: 0 8px 25px rgba(220, 38, 38, 0.3);
              display: flex;
              align-items: center;
              gap: 20px;
              animation: pulse 2s infinite;
            }

            @keyframes pulse {
              0%, 100% {
                box-shadow: 0 8px 25px rgba(220, 38, 38, 0.3);
              }
              50% {
                box-shadow: 0 8px 35px rgba(220, 38, 38, 0.5);
              }
            }

            .alert-icon {
              font-size: 48px;
              animation: ring 2s infinite;
            }

            @keyframes ring {
              0%, 100% {
                transform: rotate(0deg);
              }
              10%, 30% {
                transform: rotate(-10deg);
              }
              20%, 40% {
                transform: rotate(10deg);
              }
            }

            .alert-content h2 {
              margin: 0 0 8px 0;
              font-size: 26px;
              font-weight: 800;
            }

            .alert-content p {
              margin: 0;
              font-size: 16px;
              opacity: 0.95;
              line-height: 1.5;
            }

            .stats-grid {
              display: grid;
              grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
              gap: 20px;
              margin-bottom: 25px;
            }

            .stat-card {
              background: white;
              padding: 25px;
              border-radius: 16px;
              box-shadow: 0 4px 20px rgba(0,0,0,0.08);
              transition: all 0.3s;
              border-right: 5px solid var(--stat-color);
            }

            .stat-card:hover {
              transform: translateY(-5px);
              box-shadow: 0 8px 30px rgba(0,0,0,0.15);
            }

            .stat-card.total {
              --stat-color: #2563eb;
            }

            .stat-card.seven-days {
              --stat-color: #eab308;
            }

            .stat-card.fourteen-days {
              --stat-color: #f97316;
            }

            .stat-card.twenty-eight-days {
              --stat-color: #16a34a;
            }

            .stat-card.fifty-six-days {
              --stat-color: #0284c7;
            }

            .stat-value {
              font-size: 42px;
              font-weight: 800;
              color: var(--stat-color);
              margin: 0 0 8px 0;
              display: flex;
              align-items: center;
              gap: 12px;
            }

            .stat-label {
              font-size: 15px;
              color: #64748b;
              font-weight: 600;
              margin: 0;
            }

            .table-card {
              background: white;
              border-radius: 16px;
              padding: 30px;
              box-shadow: 0 4px 20px rgba(0,0,0,0.08);
            }

            .table-header {
              display: flex;
              justify-content: space-between;
              align-items: center;
              margin-bottom: 25px;
              padding-bottom: 20px;
              border-bottom: 3px solid #e2e8f0;
              flex-wrap: wrap;
              gap: 15px;
            }

            .table-title {
              font-size: 24px;
              font-weight: 800;
              color: #1e293b;
              margin: 0;
              display: flex;
              align-items: center;
              gap: 12px;
            }

            .filter-group {
              display: flex;
              gap: 10px;
              flex-wrap: wrap;
            }

            .filter-btn {
              padding: 10px 20px;
              border: 2px solid #e2e8f0;
              background: white;
              border-radius: 10px;
              font-size: 14px;
              font-weight: 600;
              color: #64748b;
              cursor: pointer;
              transition: all 0.3s;
            }

            .filter-btn:hover {
              border-color: #3b82f6;
              color: #3b82f6;
              transform: translateY(-2px);
            }

            .filter-btn.active {
              background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
              color: white;
              border-color: #3b82f6;
            }

            .breaking-table {
              width: 100%;
              border-collapse: separate;
              border-spacing: 0;
            }

            .breaking-table thead {
              background: linear-gradient(135deg, #1e293b 0%, #334155 100%);
            }

            .breaking-table th {
              padding: 18px 20px;
              text-align: right;
              font-size: 15px;
              font-weight: 700;
              color: white;
              border: none;
            }

            .breaking-table th:first-child {
              border-top-right-radius: 12px;
            }

            .breaking-table th:last-child {
              border-top-left-radius: 12px;
            }

            .breaking-table tbody tr {
              transition: all 0.3s;
            }

            .breaking-table tbody tr:hover {
              background: #f8fafc;
              transform: scale(1.01);
            }

            .breaking-table td {
              padding: 18px 20px;
              text-align: right;
              font-size: 15px;
              color: #334155;
              border-bottom: 1px solid #e2e8f0;
            }

            .breaking-table tr:last-child td:first-child {
              border-bottom-right-radius: 12px;
            }

            .breaking-table tr:last-child td:last-child {
              border-bottom-left-radius: 12px;
            }

            .age-badge {
              display: inline-block;
              padding: 8px 16px;
              border-radius: 20px;
              font-size: 13px;
              font-weight: 700;
            }

            .age-badge.seven {
              background: linear-gradient(135deg, #fef3c7 0%, #fde68a 100%);
              color: #854d0e;
              border: 2px solid #eab308;
            }

            .age-badge.fourteen {
              background: linear-gradient(135deg, #fed7aa 0%, #fdba74 100%);
              color: #9a3412;
              border: 2px solid #f97316;
            }

            .age-badge.twenty-eight {
              background: linear-gradient(135deg, #d1fae5 0%, #a7f3d0 100%);
              color: #065f46;
              border: 2px solid #16a34a;
            }

            .age-badge.fifty-six {
              background: linear-gradient(135deg, #bae6fd 0%, #7dd3fc 100%);
              color: #0c4a6e;
              border: 2px solid #0284c7;
            }

            .empty-state {
              text-align: center;
              padding: 80px 20px;
              color: #94a3b8;
            }

            .empty-state-icon {
              font-size: 80px;
              margin-bottom: 20px;
              opacity: 0.5;
            }

            .empty-state-title {
              font-size: 24px;
              font-weight: 700;
              color: #64748b;
              margin: 0 0 10px 0;
            }

            .empty-state-text {
              font-size: 16px;
              margin: 0;
            }

            .table-wrapper {
              overflow-x: auto;
              border-radius: 12px;
            }

            @media (max-width: 768px) {
              .breaking-container {
                padding: 15px;
              }

              .alert-banner {
                flex-direction: column;
                text-align: center;
                padding: 20px;
              }

              .alert-icon {
                font-size: 40px;
              }

              .alert-content h2 {
                font-size: 20px;
              }

              .stats-grid {
                grid-template-columns: 1fr;
              }

              .table-header {
                flex-direction: column;
                align-items: flex-start;
              }

              .breaking-table {
                font-size: 13px;
              }

              .breaking-table th,
              .breaking-table td {
                padding: 12px 8px;
              }
            }
          `}</style>

          <div className="breaking-container">
            <div className="date-picker-container">
              <label className="date-picker-label">📅 اختر تاريخ التكسير:</label>
              <EnglishDatePicker
                selected={selectedDate}
                onChange={handleDateChange}
                maxDate={new Date()}
                placeholderText="Select Date"
              />
            </div>

            <div className="alert-banner">
              <div className="alert-icon">🔢</div>
              <div className="alert-content">
                <h2>⚠️ تنبيه: مكعبات جاهزة للتكسير</h2>
                <p>
                  المكعبات التالية مطلوب تكسيرها في التاريخ المحدد - يرجى إخراجها من الحوض وتجهيزها
                </p>
              </div>
            </div>

            <div className="stats-grid">
              <div className="stat-card total">
                <h3 className="stat-value">
                  <span>📊</span>
                  {loading ? '⏳' : stats.total}
                </h3>
                <p className="stat-label">إجمالي العناصر</p>
              </div>

              <div className="stat-card seven-days">
                <h3 className="stat-value">
                  <span>7️⃣</span>
                  {loading ? '⏳' : stats.day7}
                </h3>
                <p className="stat-label">عمر 7 أيام</p>
              </div>

              {stats.day14 > 0 && (
                <div className="stat-card fourteen-days">
                  <h3 className="stat-value">
                    <span>📅</span>
                    {loading ? '⏳' : stats.day14}
                  </h3>
                  <p className="stat-label">عمر 14 يوم</p>
                </div>
              )}

              <div className="stat-card twenty-eight-days">
                <h3 className="stat-value">
                  <span>📋️</span>
                  {loading ? '⏳' : stats.day28}
                </h3>
                <p className="stat-label">عمر 28 يوم</p>
              </div>

              {stats.day56 > 0 && (
                <div className="stat-card fifty-six-days">
                  <h3 className="stat-value">
                    <span>📆</span>
                    {loading ? '⏳' : stats.day56}
                  </h3>
                  <p className="stat-label">عمر 56 يوم</p>
                </div>
              )}
            </div>

            <div className="table-card">
              <div className="table-header">
                <h2 className="table-title">
                  <span>📋</span>
                  جدول التكسير اليومي
                </h2>
                <div className="filter-group">
                  <button 
                    className={`filter-btn ${activeFilter === 'all' ? 'active' : ''}`}
                    onClick={() => setActiveFilter('all')}
                  >
                    الكل ({stats.total})
                  </button>
                  <button 
                    className={`filter-btn ${activeFilter === 'Day 7' ? 'active' : ''}`}
                    onClick={() => setActiveFilter('Day 7')}
                  >
                    7 أيام ({stats.day7})
                  </button>
                  {stats.day14 > 0 && (
                    <button 
                      className={`filter-btn ${activeFilter === 'Day 14' ? 'active' : ''}`}
                      onClick={() => setActiveFilter('Day 14')}
                    >
                      14 يوم ({stats.day14})
                    </button>
                  )}
                  <button 
                    className={`filter-btn ${activeFilter === 'Day 28' ? 'active' : ''}`}
                    onClick={() => setActiveFilter('Day 28')}
                  >
                    28 يوم ({stats.day28})
                  </button>
                  {stats.day56 > 0 && (
                    <button 
                      className={`filter-btn ${activeFilter === 'Day 56' ? 'active' : ''}`}
                      onClick={() => setActiveFilter('Day 56')}
                    >
                      56 يوم ({stats.day56})
                    </button>
                  )}
                </div>
              </div>

              {loading ? (
                <div className="empty-state">
                  <div className="empty-state-icon">⏳</div>
                  <h3 className="empty-state-title">جاري التحميل...</h3>
                  <p className="empty-state-text">يتم جلب بيانات التكسير</p>
                </div>
              ) : filteredData.length === 0 ? (
                <div className="empty-state">
                  <div className="empty-state-icon">✅</div>
                  <h3 className="empty-state-title">لا توجد مكعبات للتكسير في هذا التاريخ</h3>
                  <p className="empty-state-text">يمكنك اختيار تاريخ آخر لعرض المكعبات المطلوب تكسيرها</p>
                </div>
              ) : (
                <div className="table-wrapper">
                  <table className="breaking-table">
                    <thead>
                      <tr>
                        <th>SN</th>
                        <th>
                          <div>Casting</div>
                          <div>Date</div>
                        </th>
                        <th>Station</th>
                        <th>Location</th>
                        <th>Mix</th>
                        <th>Cube Age</th>
                        <th>Cubes</th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredData.map((pour, index) => (
                        <tr key={pour._id}>
                          <td>{index + 1}</td>
                          <td>{formatDate(pour.castingDate)}</td>
                          <td>{formatStationName(pour.station)}</td>
                          <td>{pour.location}</td>
                          <td>{pour.mix}</td>
                          <td>
                            <span className={`age-badge ${
                              pour.age === 'Day 7' ? 'seven' :
                              pour.age === 'Day 14' ? 'fourteen' :
                              pour.age === 'Day 28' ? 'twenty-eight' : 'fifty-six'
                            }`}>
                              {pour.age}
                            </span>
                          </td>
                          <td style={{ fontWeight: '700', color: '#1e40af', fontSize: '14px' }}>
                            {pour.cubesCount?.groups && pour.cubesCount?.cubesPerGroup 
                              ? `${pour.cubesCount.groups}G × ${pour.cubesCount.cubesPerGroup} = ${pour.cubesCount.total}C`
                              : '-'
                            }
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TodaysBreaking;